/* unplugin-vue-components disabled */import { render } from "./memberNav.vue?vue&type=template&id=3e068fc7&scoped=true"
import script from "./memberNav.vue?vue&type=script&lang=js"
export * from "./memberNav.vue?vue&type=script&lang=js"

import "./memberNav.vue?vue&type=style&index=0&id=3e068fc7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e068fc7"]])

export default __exports__